import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedLayoutModule } from '../shared-layout/shared-layout.module';
import { ControlDisabledDirectiveModule } from '../libs/ui/directives/control-disabled/control-disabled-directive.module';
import { DashboardUserAccessDetailComponent } from './dashboard-user-access-detail/dashboard-user-access-detail.component';
import { SharedUserAccessDetailDefaultComponent } from './shared-user-access-detail-default/shared-user-access-detail-default.component';
import { DashboardUserManagementComponent } from './dashboard-user-management/dashboard-user-management.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { SharedUserListModule } from '../shared-layout/Components/shared-user-list/shared-user-list.module';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { UserListItemsModule } from '../shared-layout/Components/user-list-items/user-list-items.module';
import { SelectSiteModule } from '../building-managment/select-site/select-site.module';
import { MultiUserShareAccessModule } from '../user-management/multi-user-share-access/multi-user-share-access.module';
import { DashboardActiveIssuesManagementComponent } from './dashboard-active-issues-management/dashboard-active-issues-management.component';
import { DashboardActiveIssuesDetailComponent } from './dashboard-active-issues-detail/dashboard-active-issues-detail.component';
import { SharedActiveIssuesListModule } from '../shared-layout/Components/shared-active-issues-list/shared-active-issues-list.module';
import { LockNotFoundComponent } from './dashboard-active-issues-detail/lock-not-found/lock-not-found.component';
import { DashboardUserAccessMessageComponent } from './dashboard-user-access-message/dashboard-user-access-message.component';
import { SameUserIdControlDirectiveModule } from '../libs/ui/directives/same-userid-control/same-userid-control-directive.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SortByModule } from '../libs/ui/pipes/sort-by/sort-by.module';
import { DashboardActiveIssuesAccesspointDetailComponent } from './dashboard-active-issues-accesspoint-detail/dashboard-active-issues-accesspoint-detail/dashboard-active-issues-accesspoint-detail.component';
import { DeviceNotFoundComponent } from './dashboard-active-issues-accesspoint-detail/device-not-found/device-not-found/device-not-found.component';
import { ProfilePictureModule } from '../shared-layout/Components/profile-picture/profile-picture.module';
import { HideAccessModule } from '../libs/ui/directives/hide-access/hide-access.module';
import { WithTooltipModule } from '../shared-layout/Components/with-tooltip/with-tooltip.module';
import { LocalizationService } from '../shared/services/localization.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    DashboardComponent,
    DashboardUserAccessDetailComponent,
    DashboardUserManagementComponent,
    SharedUserAccessDetailDefaultComponent,
    DashboardActiveIssuesManagementComponent,
    DashboardActiveIssuesDetailComponent,
    LockNotFoundComponent,
    DashboardUserAccessMessageComponent,
    DashboardActiveIssuesAccesspointDetailComponent,
    DeviceNotFoundComponent,
  ],
  imports: [
    CommonModule,
    SharedLayoutModule,
    WithTooltipModule,
    ControlDisabledDirectiveModule,
    DashboardRoutingModule,
    SharedUserListModule,
    NgbNavModule,
    UserListItemsModule,
    SelectSiteModule,
    MultiUserShareAccessModule,
    SharedActiveIssuesListModule,
    SameUserIdControlDirectiveModule,
    LazyLoadImageModule,
    SortByModule,
    ProfilePictureModule,
    HideAccessModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    LocalizationService,
    TranslateModule
  ],
  exports: [RouterModule],
})
export class DashboardModule {}
